import { AlertCircle, Check, CheckCheck, Clock } from 'lucide-react';
import type { WhatsappMessage } from '../api/whatsapp.api';

/**
 * WhatsApp-style status indicator for outbound messages.
 *   PENDING/queued  → clock
 *   SENT            → single check
 *   DELIVERED       → double check
 *   READ            → double check (blue)
 *   FAILED          → red alert
 */
export function StatusTicks({ status, size = 14 }: { status: WhatsappMessage['status']; size?: number }) {
  switch (status) {
    case 'PENDING':
      return <Clock size={size} className="opacity-60" />;
    case 'SENT':
      return <Check size={size} className="opacity-80" />;
    case 'DELIVERED':
      return <CheckCheck size={size} className="opacity-80" />;
    case 'READ':
      return <CheckCheck size={size} className="text-sky-400" />;
    case 'FAILED':
      return <AlertCircle size={size} className="text-red-400" />;
    default:
      return null;
  }
}
